import React, {Component} from 'react'
import Button from 'antd/lib/button'
import Input from 'antd/lib/input'
import Form from 'antd/lib/form'
import {
    setUserAttributes,
    showAdditionalForm,
    setErrorMessage
} from "../../../redux/auth/actions"

import {validatePassword} from "../helpers"

const styles = {
    button: {
        backgroundColor: '#1BAAF1',
        borderColor: '#1BAAF1'
    }
}

class RegistrationForm extends Component {
    state = {
        token: '',
        confirmDirty: false,
        errorMessage: ''
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const {email, password, first_name, last_name } = values

                if(validatePassword(password)) {
                    const attributes = {
                        email: email.toLowerCase(),
                        given_name: first_name,
                        family_name: last_name,
                        password: password,
                        'custom:d1': `${this.props.tenant.tenant.d1}#${this.props.tenant.tenant.pk}`
                    }

                    setUserAttributes(attributes)
                    showAdditionalForm(true)
                    setErrorMessage("")
                } else {
                    setErrorMessage("Invalid password complexity: Passwords must be at least 6 characters and include one number")
                }
            }
        });
    }

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    }

    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('The two passwords must match!');
        } else {
            callback();
        }
    }

    validateToNextPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], { force: true });
        }
        callback();
    }


    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 16,
                    offset: 8,
                },
            },
        };

        return (
            <React.Fragment>
                <Form {...formItemLayout} onSubmit={this.handleSubmit}>
                    <Form.Item {...formItemLayout} label="First Name">
                        {getFieldDecorator('first_name', {
                            rules: [{
                                required: true,
                                message: 'Please input your first name',
                                initialValue: this.props.attributes ? this.props.attributes.given_name : ''
                            }],
                        })(
                            <Input placeholder="Please input your first name" />
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="Last Name">
                        {getFieldDecorator('last_name', {
                            rules: [{
                                required: true,
                                message: 'Please input your last name',
                                initialValue: this.props.attributes ? this.props.attributes.family_name : ''
                            }],
                        })(
                            <Input placeholder="Please input your last name" />
                        )}
                    </Form.Item>
                    <Form.Item
                        label="E-mail"
                    >
                        {getFieldDecorator('email', {
                            rules: [{
                                type: 'email', message: 'The input is not valid E-mail!',
                            }, {
                                required: true, message: 'Please input your E-mail!',
                            }],
                            initialValue: this.props.attributes ? this.props.attributes.email : ''
                        })(
                            <Input />
                        )}
                    </Form.Item>
                    <Form.Item
                        label="Password"
                    >
                        {getFieldDecorator('password', {
                            rules: [{
                                required: true, message: 'Please input your password!',
                            }, {
                                validator: this.validateToNextPassword,
                            }],
                            initialValue: this.props.attributes ? this.props.attributes.password : ''
                        })(
                            <Input type="password" />
                        )}
                    </Form.Item>
                    <Form.Item
                        label="Confirm Password"
                    >
                        {getFieldDecorator('confirm', {
                            rules: [{
                                required: true, message: 'Please confirm your password!',
                            }, {
                                validator: this.compareToFirstPassword,
                            }],
                        })(
                            <Input type="password" onBlur={this.handleConfirmBlur} />
                        )}
                    </Form.Item>
                    <Form.Item {...tailFormItemLayout}>
                        <Button style={styles.button} type="primary" htmlType="submit">Next</Button>
                    </Form.Item>
                </Form>
            </React.Fragment>
        );
    }
}

export default Form.create({ name: 'register' })(RegistrationForm);